export default {
  'zh-CN': require('./zh-CN').default,
  en: require('./en').default,
  'zh-HK': require('./zh-HK').default,
}
